require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gnie-civil-2-2-2-5.json") })
        }
      }, "path---gnie-civil-2-2-2-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gnie-civil-2-2-2-5!./.cache/json/gnie-civil-2-2-2-5.json
// module id = 446
// module chunks = 231608221292675